import React, { useMemo, useState } from "react";
import {
  Button, Col, Container, FormControl, FormGroup,
  InputGroup, Row
} from "react-bootstrap";
import { injectIntl } from "react-intl";
import { queryCache, useMutation, useQuery } from "react-query";
import Alert from "react-s-alert";
import ArchiveHeader from "../../../components/ArchiveHeader";
import CreateItemForm from '../../../components/CreateItemForm';
import PageLoading from "../../../components/Loading";
import AssociationRow from "../../../components/scheduleRows/associationrow";
import Table from '../../../components/TableNew';
import { deleteSchedule, getSchedule } from '../schedules/xhr';





const Associations = ({ intl, locale, setLocale }) => {
  const [search, setSearch] = useState("");
  const [associationName, setAssoiciationName] = useState('')

  const { isLoading, isError, error, data: schedule } = useQuery('schedule', getSchedule, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [deleteAssociationMutation] = useMutation(deleteSchedule, {
    onSuccess: (deletedAssociation) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          associations: schedule.associations.filter(association => association._id !== deletedAssociation._id)
        }))
      }
      Alert.success(intl.formatMessage({ id: 'color.delete-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const columns = useMemo(
    () => [
      {
        Header: "Associations",
        accessor: ({ _id, ...row }) => {
          return Object.values(row).join("|");
        },
        Cell: ({ cell: { value }, row: { original } }) => (
          // <pre>{JSON.stringify(original, null, 2)}</pre>
          <AssociationRow
            key={original._id}
            id={original._id}
            name={original.name}
            login={original.login}
            password={original.password}
            logo={original.logo}
            deleteFn={(collection,_id) => {
              deleteAssociationMutation({collection, _id })
            }}
          />
        ),
      },
    ],
    [deleteAssociationMutation]
  );

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="tab.schedule-associations" />
      <div className="pad-2rem">
        <Container fluid>
          <Row className="align-items-center m-b-20">
            <Col lg={6}>
              <CreateItemForm
                heading="button.s.association-create"
                setFunc={setAssoiciationName}
                placeholder={intl.formatMessage({ id: 'button.s.association-create' })}
                link={`/association/add/${associationName}`}
              />
            </Col>
            <Col lg={6}>
              <Row>
                <Col></Col>
                <Col md={5}>
                  <div className="text-right search-container">
                    <FormGroup>
                      <InputGroup onChange={(e) => setSearch(e.target.value)}>
                        <FormControl type="text" />
                        <InputGroup.Append>
                          <Button>
                            <img src="/icons/search.png" alt="plus" />
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table columns={columns} data={schedule.associations} search={search} intl={intl} />
              {/* <pre>{JSON.stringify(schedule, null, 2)}</pre> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};


export default injectIntl(Associations);
